module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.library.js
// module id = 692
// module chunks = 0